import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { pickRealStore } from "@/lib/merchantStore";

export const useCurrentStoreId = () => {
  const [storeId, setStoreId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) { setIsLoading(false); return; }

        // Real store first (store_settings), never the empty auto-created "my-store" row.
        const [{ data: settings }, { data: stores }] = await Promise.all([
          supabase.from("store_settings").select("id, created_at").eq("user_id", user.id),
          supabase.from("stores").select("id, created_at").eq("owner_id", user.id),
        ]);

        setStoreId(pickRealStore(settings, stores)?.row.id ?? null);
      } catch {
        setStoreId(null);
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, []);

  return { storeId, isLoading };
};
